import type Notes from '$components/reader/Notes.svelte';
import type ReaderSettingsComponent from '$components/reader/ReaderSettings.svelte';
import type {
  ActiveBookIndexes,
  BibleGroup,
  FloatingFootnote,
  HighlightedVerse,
  PersonalNote,
  ReaderSettings
} from '$types/bible';
import type { DonationPledge, EmailRequest, PremiumFile } from '$types/interfaces';
import { writable } from 'svelte/store';

export const english = writable(false);

export const editableTranslations = writable<Set<string>>(new Set());

export const readerSettings = writable<ReaderSettings>({
  fontSize: 'medium',
  fontFamily: 'Merriweather',
  backgroundColor: 'light',
  showVerseNumbers: true,
  infiniteScroll: false,
  rememberChapter: false,
  doubleView: false
});

export const mobileBreakpoint = 720;

export const bible = writable<BibleGroup[]>([]);

export const activeBook = writable<ActiveBookIndexes>({
  group: 0,
  book: 0
});

export const activeBookChapter = writable<number>(-1);
export const activeBookChapterJump = writable<boolean>(true);

export const secondActiveBook = writable<ActiveBookIndexes>({
  group: 0,
  book: 0
});

export const secondActiveBookChapter = writable<number>(-1);
export const secondActiveBookChapterJump = writable<boolean>(true);

export const jumpToVerse = writable<HighlightedVerse | null>(null);

export const jumpToSecondaryVerse = writable<HighlightedVerse | null>(null);

export const globalError = writable<string | null>(null);
export const globalErrorId = writable<string | null>(null);

export const highlightedVerse = writable<HighlightedVerse | null>(null);

export const personalNotes = writable<PersonalNote[]>([]);

export const allowCreatingNotes = writable<boolean>(false);

export const creatingNote = writable<boolean>(false);

// id of PersonalNote to be edited
export const editingNote = writable<string | null>(null);

export const showLogin = writable<boolean>(false);
export const showDashboard = writable<boolean>(false);
export const showDashboardSettings = writable<boolean>(false);

export const showEmailBlocker = writable<boolean | EmailRequest>(false);

export const promptLogin = writable<'confirm' | 'settings' | boolean>(false);

export const showPledge = writable<boolean>(false);

export const pledgeInfo = writable<DonationPledge | null>(null);

export const overscrollScrolled = writable<boolean>(false);

export const primaryQuery = writable<string>('');

export const secondaryQuery = writable<string>('');

export const selectionStartVerse = writable<HighlightedVerse | null>(null);
export const selectionEndVerse = writable<HighlightedVerse | null>(null);

export const mouseDown = writable<boolean>(false);

export const selectionText = writable<string>('');

export const readerSidebar = writable<typeof ReaderSettingsComponent | typeof Notes | undefined>(
  undefined
);

export const mobileSearch = writable<boolean>(false);

export const scrollEnabled = writable<boolean>(true);

export const premiumFiles = writable<PremiumFile[]>([]);

export const images = writable<{ [key: string]: string }>({});

export const adminMode = writable<boolean>(false);

export const floatingFootnote = writable<FloatingFootnote | null>(null);

export const showCookiesPopup = writable<boolean | undefined>(undefined);

export const youtubeModal = writable<string | undefined>(undefined);
export const audiomackModal = writable<string | undefined>(undefined);

export const remindToDonate = writable<boolean>(false);

export const isEmbedded = writable<boolean>(false);
